// ─── I capitoli del menu che si chiudono ─────────────────────────────────────
//
// 🗣️ 26/09/2026: *«il menu laterale sta diventando abbastanza imponente… le
// sezioni impostazioni, Telegram e chi entra fammele che si possono contrarre.
// Con una freccetta.»* · *«il lavoro non me lo contrai»*. Mockup approvato:
// `mockup/menu-a-capitoli-chiudibili-mockup.html`.
//
// ⚖️ Qui ci sono solo le regole, senza React: quale capitolo è aperto, quale si
// apre arrivando su una pagina e quale numero sale sul titolo chiuso. Si provano una per
// una, senza dover montare il gestionale.

/**
 * 🔄 **Non si ricordano fra un'apertura e l'altra — 26/09/2026, richiesta sua.**
 * 🗣️ *«quando apro il gestionale deve essere chiusa di default»*. Fino a quel
 * giorno il browser si ricordava i capitoli aperti (`pmo.menu.aperti`): adesso
 * ogni apertura del gestionale parte coi capitoli chiusi, e mentre si lavora
 * restano come li si lascia, perché il guscio non si smonta cambiando pagina.
 */

/**
 * 📍 La pagina in cui si è sta dentro questo capitolo? Stessa regola di
 * `NavLink`: l'indirizzo della voce, o qualcosa sotto di lui.
 */
export function contieneLaPagina(voci: ReadonlyArray<{ dove: string }>, pagina: string): boolean {
  return voci.some((v) => pagina === v.dove || pagina.startsWith(`${v.dove}/`));
}

/**
 * Un capitolo si vede aperto se non si chiude («lavoro») oppure se è aperto.
 *
 * 🔄 **Fino al 26/09/2026 si vedeva aperto anche quando dentro c'era la pagina
 * in cui si era, e la freccetta lì non rispondeva.** 🗣️ *«Non mi funziona
 * apertura e chiusura di impostazioni»*: da Campi o da Caparra il tocco su
 * «impostazioni» non faceva niente. Mockup approvato:
 * `menu-freccetta-sempre-mockup.html`. ⇒ Adesso la freccetta decide sempre, e
 * la pagina apre il suo capitolo solo quando ci si arriva
 * (⇒ `apriIlCapitoloDellaPagina`).
 */
export function capitoloAperto(
  capitolo: { nome: string; chiudibile?: true },
  aperti: ReadonlySet<string>,
): boolean {
  return !capitolo.chiudibile || aperti.has(capitolo.nome);
}

/**
 * 📍 Arrivando su una pagina, il suo capitolo si apre da solo. Se poi lo si
 * chiude resta chiuso: questa si chiama solo quando la pagina cambia.
 *
 * Torna lo **stesso** insieme se non c'è niente da aprire, così chi la chiama
 * non ridisegna il menu per niente.
 */
export function apriIlCapitoloDellaPagina(
  aperti: ReadonlySet<string>,
  capitoli: ReadonlyArray<{ nome: string; chiudibile?: true; voci: ReadonlyArray<{ dove: string }> }>,
  pagina: string,
): ReadonlySet<string> {
  const qui = capitoli.find((c) => c.chiudibile && contieneLaPagina(c.voci, pagina));
  if (!qui || aperti.has(qui.nome)) return aperti;
  return new Set([...aperti, qui.nome]);
}

/**
 * 🔴 Il numero che sale sul titolo di un capitolo chiuso: la somma dei bollini
 * delle voci che la freccetta nasconde. Senza, un numero rosso sparirebbe
 * proprio quando serve vederlo.
 */
export function bollinoDelCapitolo(
  voci: ReadonlyArray<{ conta?: 'suggerimenti' | 'avvisi' | 'da-segnare' }>,
  conte: { suggerimenti: number; avvisi: number; 'da-segnare': number },
): number {
  return voci.reduce((somma, v) => somma + (v.conta ? conte[v.conta] : 0), 0);
}
